<template>
  <div
    v-if="config.showHeader"
    id="header"
    :class="['header', { bg: config.showBg, shadow: config.shadow }]"
  >
    <div v-if="!storeOpened" class="header-tip bg-orange-1 text-grey-8">
      <q-icon name="font:dm-waring" color="#000" size="20px" />
      <span bold>
        {{ $t('common.header.close') }}
      </span>
      <span v-if="scheduledOpened" bold>
        ,{{ $t('common.header.closeScheduled') }}
      </span>
    </div>
    <div class="header-core">
      <div :class="['header-icon', { bg: !config.showBg }]">
        <q-circular-progress
          v-if="isLoading"
          :thickness="0.25"
          indeterminate
          size="20px"
        />
        <i v-else class="iconfont dm-arrow-left" @click="onBack" />
      </div>
      <h1 bold class="header-title">{{ title }}</h1>
      <div v-if="showUser" class="header-ricon" @click="goToUser">
        <i class="iconfont dm-List" />
        <span v-if="count" class="badge">{{ count }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getReadyOrder } from 'src/api/home.js';
import { ref, computed, watch, nextTick } from 'vue';
import { useIns, useStore } from '../../utils/v2_helper/common';
import { useRoute, useRouter } from '../../utils/v2_helper/router';
import { getToken } from '../../utils/common';

const app = useIns();
const store = useStore();
const router = useRouter();
const route = useRoute();

const isLoading = ref(false);
const title = ref('');
const address = ref('');
const count = ref('');
const showTips = ref(false);

const config = computed(() => route.meta.header || {});
const showUser = computed(
  // 加上未登录和游客不显示订单历史的逻辑
  () => config.value.showUser && app.storeInfo.status?.statusCode !== 400 && app.logged && !app.userInfo?.guestUser,
);

// =====func=====
function onBack() {
  isLoading.value = true;
  if (address.value) return router.push({ path: address.value });
  router.go(-1);
}
function goToUser() {
  store.dispatch('Menu/setToLoginPath', 'user');
  if (app.logged) {
    return router.push({ path: `/${app.storeUrl}/user/order-history` });
  }
  router.push({ path: `/${app.storeUrl}/login` });
}

watch(
  () => route.path,
  (_) => {
    nextTick(() => {
      const { name, path } = route;
      // 解决返回按钮一直loading的情况
      isLoading.value = false;
      // 列表页 标题 订单数量
      if (['products-list', 'search'].includes(name)) {
        if (process.env.CLIENT && getToken(app)) {
          getReadyOrder().then(({ success, data }) => {
            if (success) count.value = data;
          });
        }
        title.value = app.storeInfo?.name;
      } else {
        title.value = app.$t(config.value.title) || app.storeInfo?.name;
      }
      // 登录页返回地址
      if (name === 'login') {
        if (app.toLoginPath === 'checkout') {
          address.value = `/${app.storeUrl}/cart`;
        }
        if (app.toLoginPath === 'user') {
          address.value = `/${app.storeUrl}/products-list`;
        }
      } else if (config.value.backLink) {
        if (config.value.backLink === 'home') {
          address.value = `/${app.storeUrl}`;
        } else {
          address.value = `/${app.storeUrl}/${config.value.backLink}`;
        }
      } else {
        address.value = '';
      }
    });
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
  background: transparent;
  &.shadow {
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);
  }
  &.bg {
    background: #fff;
  }
  &-tip {
    padding: 8px;
  }
  &-core {
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 64px;
  }
  &-title {
    line-height: 1;
    font-size: 21px;
    margin-left: 10px;
  }
  &-icon {
    font-size: 24px;
    line-height: 64px;
    padding: 0 8px;
    &.bg {
      background: #fff;
      height: 40px;
      width: 40px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &-ricon {
    font-size: 26px;
    margin-left: auto;
    margin-right: 6px;
    position: relative;
    .badge {
      position: absolute;
      top: 1px;
      right: -5px;
      background: $primary;
      color: #fff;
      font-size: 12px;
      height: 16px;
      padding: 0 5px;
      border-radius: 12px;
      font-weight: bold;
    }
  }
  .iconfont {
    font-size: 1em;
  }
}
</style>
